import {color} from "@khanacademy/wonder-blocks-tokens";

import type {NewTooltipProps} from "./types.ts";

/**
 * Given a set of NewTooltipProps, return the `backgroundColor` and `textColor`
 * of the tooltip. Used in TooltipArrow and TooltipBubble.
 */
export function getTooltipColors(tooltipProps: NewTooltipProps): {
    backgroundColor: string;
    textColor: string;
} {
    const {color: tooltipColor, inverted} = tooltipProps;

    if (inverted) {
        return {backgroundColor: tooltipColor, textColor: color.white};
    }
    return {backgroundColor: color.white, textColor: tooltipColor};
}
